"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Fetch {
    constructor(client) {
        this.fetch = async (url, headers, intercept, defaultValue) => {
            try {
                const data = await this.client.get(url, null, {
                    responseType: "arraybuffer",
                }, {
                    ...headers,
                    Accept: "image/*",
                }, intercept);
                /* istanbul ignore next */
                // @ts-ignore
                const b64encoded = Buffer.from(data, "binary").toString("base64");
                // @ts-ignore
                return `data:image/jpeg;base64,${b64encoded}`;
            }
            catch (e) {
                if (!defaultValue) {
                    throw e;
                }
                return defaultValue;
            }
        };
        this.client = client;
    }
}
exports.default = Fetch;
//# sourceMappingURL=Fetch.js.map